var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import userClient from '../config/api/userClient';
var publisherUrl = "publishers";
var publisherRevenueUrl = "publishers/revenue";
var publisherPlatformUrl = "publishers/byPlatform";
export var getPublisher = function (params) {
    return userClient.get(publisherUrl, {
        params: __assign({ includeSummaryReport: params.includeSummaryReport }, ((params === null || params === void 0 ? void 0 : params.uiTarget) ? { uiTarget: params === null || params === void 0 ? void 0 : params.uiTarget } : {})),
    });
};
export var getPublisherRevenue = function (params) {
    return userClient.get("" + publisherRevenueUrl, { params: params });
};
export var getPublisherByPlatformIds = function (platformIds) {
    return userClient.get("" + publisherPlatformUrl, { params: { platformIds: platformIds } });
};
